<template>
	<v-img
		class="picture"
		:class="{ 'picture--no-img bg-grey' : !this.link || this.hasImgError }"
		:src="src"
		:width="imgWidth"
		:height="imgHeight"
		:cover="cover"
		:aspect-ratio="aspectRatio"
		@error="setErrorOfImg"
	/>
</template>
<script>
export default {
	name: 'Picture',
	props: {
		src: {
			type: String,
			default: '',
		},
		width: {
			type: [Number, String],
			default: null,
		},
		height: {
			type: [Number, String],
			default: 'auto',
		},
		mobileHeight: {
			type: [Number, String],
			default: 'auto',
		},
		cover: {
			type: Boolean,
			default: false,
		},
		aspectRatio: {
			type: Number,
			default: 4/2.5
		}
	},
	data () {
		return {
			hasImgError: false
		}
	},
	computed: {
		smSize() { return 600; },
		imgWidth() {
			return this.width;
		},
		imgHeight() {
			if(window.innerWidth <= this.smSize) return this.mobileHeight || this.height;

			return this.height;
		},
		link() { return this.src }
	},
	methods: {
		isNumberType (val = null) {
			return typeof(val) === 'number'
		},
		setErrorOfImg (error) {
			this.hasImgError = !!error
		}
	}
};
</script>
<style lang="scss" scoped>
.picture {
	border-radius: 10px;
	box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.15);
	&--no-img {
		position: relative;
		&:before {
			content: url(/img/icons/logo.svg);
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
	}
}
</style>
